import PropTypes from 'prop-types';

// INPUT MASK
const maskString = {
  apply(value, pattern = '') {
    let i = 0;
    const v = value?.toString() ?? '';
    /* eslint-disable */
    return pattern.replace(/#/g, () => v[i++]).replace(/undefined/g, '');
  },
  remove(value, pattern = '') {
    let originalValue = '';
    const v = value?.toString() ?? '';

    /* eslint-disable */
    pattern.replace(/#/g, (_, index) => (originalValue += v[index]));
    /* eslint-enable */
    return originalValue.replace(/undefined/g, '');
  },
};

export const cepInputMask = (value) => {
  return maskString.apply(value, '#####-###');
};
cepInputMask.propTypes = {
  value: PropTypes.string,
};

// FORMATS MASK
export const cepMask = (cep) => {
    cep = cep.replace(/\D/g, '');
    
    return cep.replace(/^(\d{5})(\d{3})$/, '$1-$2');
};

cepMask.propTypes = {
  cep: PropTypes.string,
};

export const pointsMask = (number) => {
  const roundedNumber = parseFloat(number).toFixed(2);
  const parts = roundedNumber.split('.');
  const formattedInteger = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  const formattedNumber = `${formattedInteger},${parts[1]}`;

  return formattedNumber;
};

export const ratePointsMask = (number) => {
  const roundedNumber = parseFloat(number).toFixed(1);
  const parts = roundedNumber.split('.');
  const formattedInteger = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  const formattedNumber = `${formattedInteger},${parts[1]}`;

  return formattedNumber;
};

pointsMask.propTypes = {
  number: PropTypes.number,
};

export const currencyMask = (number) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  return formatter.format(number);
};
currencyMask.propTypes = {
  number: PropTypes.number,
};

export const phoneMask = (areaCode, phoneNumber) => {
  const cleanedValue = `${areaCode}${phoneNumber}`.replace(/\D/g, '');

  const formattedValue = cleanedValue.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');

  return formattedValue;
};
